<div class="price-calendar-wrapper">
    @if (calendarRows?.length > 0) {
        <div class="price-calendar">

            <div class="nights-column">
                <div class="column__cell column__cell-bg">Дней</div>
                @for (row of calendarRows; track row.nights) {
                    <div class="column__cell column__cell-bg" [attr.data-value]="row.nights">
                        {{ row.nights + 1 }}
                    </div>
                }
            </div>

            <div class="swiper" id="swiperCalendar">
                <div class="swiper-wrapper">
                    @for (date of datesGrid; track date.date) {
                        <div class="swiper-slide swiper-slide-col">
                            <div class="column__cell column__cell-date column__cell-bg">
                                <span class="date-top">{{ date.day }} {{ date.weekday }}</span>
                                <span class="date-month">{{ date.month }}</span>
                            </div>

                            @for (row of calendarRows; track row) {
                                @let price = getPriceForDate(row, date.date);
                                <div class="column__cell"
                                     [ngClass]="{'isBest': !!price?.isBest, 'active': isActiveCell(price?.price?.value || 0, price?.nights ?? row.nights, price?.date ?? date.date), 'isEmpty': !price || price.price.value === 0}"
                                     (click)="handleClick(price?.price?.value || 0, price?.nights ?? row.nights, price?.date ?? date.date, $event)"
                                     [attr.data-nights]="price?.nights ?? row.nights"
                                     [attr.data-date]="price?.date ?? date.date"
                                >
                                    {{ price && price.price.value !== 0 ? (price.price.value | priceFormat:price.price.currency) : '-' }}
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    }

    @if (isShowSkeleton) {
        <div class="price-calendar">
            <app-hotel-price-calendar-skeleton/>
        </div>
    }
</div>
